import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"dense":"","items":_vm.taskPresets,"item-text":"display","item-value":"display","hide-no-data":"","hide-details":"","placeholder":_vm.$t('labels.tasks'),"menu-props":{ closeOnContentClick: true },"loading":_vm.loading},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }